// extracted by mini-css-extract-plugin
export default {"overlay":"Loading_overlay__lDqvu","wrapper":"Loading_wrapper__eWuOZ","loadingWrapper":"Loading_loadingWrapper__QTxam"};